export const PriceTargetsLegend = ({
  collapsed = false,
}: {
  collapsed?: boolean;
}) => (
  <div
    className={`
      flex
      ${collapsed && 'flex-col p-3'}
      items-center
      justify-center
      gap-4
      mr-2
    `}
  >
    <div className="flex items-center gap-2">
      <div className="rounded-full bg-negative w-3 h-3"></div>
      <p className="text-xs">Actual loss</p>
    </div>
    <div className="flex items-center gap-2 mr-4">
      <div className="rounded-full bg-positive w-3 h-3"></div>
      <p className="text-xs">Actual profit</p>
    </div>
  </div>
);
